// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import { Authenticated } from '../auth';
import ViewAnalytics from './ViewAnalytics';

export default {
  path: 'analytics',
  name: 'Analytics',
  component: Authenticated,
  childRoutes: [
    {
      path: '/analytics',
      childRoutes: [
        { path: '', component: ViewAnalytics },
      ],
    },
  ],
};
